<!--Footer Starts-->
<footer class="footer" [class.fixedFooter]="isAuthPage">
  <div class="container-fluid px-4">
    <div class="d-flex align-items-center justify-content-between small">
      <div class="text-muted text-center">
        <a style="font-size: 11px;" class="d-block">{{ 'global.footerText' | translate }}.</a> <br>
        <div style="text-align: center;">
          <span>© {{ currentYear }} {{ 'global.footerCopyright' | translate }}</span>
          {{ 'global.footerImageText' | translate }}
          <a href="https://www.computergalaxy.it/" target="_blank">Computer Galaxy</a>
          <br>
          <a href="https://cinetel.it/pages/p.php?idtxpg=6&titolo=Informativa_Sulla_Privacy" *ngIf="!isAuthPage" target="_blank">Informativa Sulla Privacy</a>
        </div>
      </div>
    </div>
  </div>
</footer>
<!--Footer Ends-->
